/* eslint-disable eqeqeq */
import { FC, useEffect, useMemo, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";

import { withProcedureWraper } from "../..";
import { Routes } from "../../../../AppRoutes";
import { Box } from "../../../../components/box";
import { InputArrayData, InputNumber, InputSelect, InputText } from "../../../../components/input";
import { Button } from "../../../../modules/button";
import { InputWraper, useForm } from "../../../../modules/form";
import { useSelector } from "../../../../store/store";
import { CreateNotification } from "../../../../components/notifier";
import { Icon } from "../../../../components/icon";
import { MailService } from "../../../../services/mail/mail.service";
import { UserSelect } from "../../../../components/input/select/UserSelect";

import { getEnv } from "../../../../AppConfigs";
import { mailRegexs } from "../../../../constants/mailTemplateConstants";
import { requestStatus } from "../../../../constants/statusConstants";

import { Col, Row } from "react-bootstrap";
import { PeoplePicker, PersonType } from "@microsoft/mgt-react";
import { validatePhoneNumber, validateRequests } from "../../../../services/util";
import { getDDMMYYYFormat, getDay, getHHmmFormat, setUtcTime } from "../../../../helper/dateTimeHelper";
import {
  department,
  hq1Team,
  hq2Team,
  hq3Team,
  psc1Team,
  psc2Team,
  psc3Team,
  pvhk1Team,
  pvhk2Team,
  pvhk3Team,
  unitDN,
  unitNB,
  unitTSN,
} from "../../info-technology-process/data";
import { codeProcessRequestTypes } from "../../info-technology-process/code-process/codeRequestType";
import { InputSelectTag } from "../../../../components/input/select-tag";
import {
  eApprovedOptions,
  stageRequest,
  suggestionRequest,
  suggestionTicketRequest,
} from "../companyRequestContants/companyRequestContants";
import { ExternalSecurityControlCardRequestService } from "../../../../services/company-office/ExternalSecurityControlCardService";
import {
  LongTermEvictSecurityControlCardContentForm,
  LongTermEvictSercurityCardUnitsFormStructure,
  LongTermNewSecurityControlCardContentForm,
  LongTermNewSercurityCardUnitsFormStructure,
  LongTermRenewSecurityControlCardContentForm,
  longTermRenewSecurityControlCardStructure,
} from "./longTermExternalSCCForm";
import {
  ShortTermRenewSercurityCardUnitsControlForm,
  ShortTermRenewSercurityCardUnitsFormStructure,
  ShortTermSercurityCardUnitsControlForm,
  ShortTermSercurityCardUnitsFormStructure,
} from "./shortTermExternalSCCForm";
import { Upload } from "../../upload";
import { eApproveTitleCode } from "../../../../constants/bizTitle";
import { isProduction } from "../../../../helper/util";

const siteUrl = getEnv("REACT_APP_APPROVER_SECURITY_CONTROL_CARD_TO_EXTERNAL_REQUEST_URL");

export const createSercurityCardUnitsPage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const params = useRouteMatch().params as any;
  const id = +params.id;
  const oldEmployees = useSelector((state: any) => {
    return state.employee.employees;
  });

  const employees = useMemo(() => {
    const newData = [...(oldEmployees || [])]

    if (!isProduction) {
      newData.push({
        eMail: 'namphuonghc@viags.vn',
        Title: 'HC eOffice',
      });
      newData.push({
        eMail: 'namphuongtp@viags.vn',
        Title: 'TP eOffice',
      });
      newData.push({
        eMail: 'namphuongth@viags.vn',
        Title: 'TH eOffice',
      });
      newData.push({
        eMail: 'namphuongcb@viags.vn',
        Title: 'CB eOffice',
      });
    }

    return newData
  }, [oldEmployees]);
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const user = useSelector((state: any) => state.user);

  const [approverOptions, setApproverOptions] = useState([]);
  const today = new Date();
  const [estimatedTimeOfUse, setEstimatedTimeOfUse] = useState(today);
  const [approver, setApprover] = useState(null as any);
  const [itLead, setItLead] = useState(null as any);

  const [sercurityCardUnitRequestType, setsercurityCardUnitRequestType] = useState(codeProcessRequestTypes[0].value);
  const [selectedDepartment, setSelectedDepartment] = useState(null as any);
  const [selectedUnit, setSelectedUnit] = useState(null as any);
  const [unit, setUnit] = useState<any>([]);
  const [stage, setStage] = useState(stageRequest[0].value as any);
  const [team, setTeam] = useState<any>([]);
  const [suggestion, setSuggestion] = useState(
    stage === "longTerm" ? (suggestionRequest[0].value as any) : (suggestionTicketRequest[0].value as any),
  );
  const [pickedUserName, setPickedUserName] = useState(null as any);
  const [pickedItLeadName, setPickedItLeadName] = useState(null as any);
  const [contentData, setContentData] = useState<any>([]);

  const { getInputProps, handleSubmit, isSubmitting, setValues } = useForm({
    structure: [
      {
        name: "stage",
        label: "Giai đoạn thẻ KSAN",
      },
      {
        name: "type",
        label: "Yêu cầu",
      },
      {
        name: "phoneNumber",
        label: "SĐT liên hệ",
      },
      {
        name: "description",
        label: "Mô tả",
      },
      {
        name: "baseId",
        label: "Căn cứ nhu cầu",
      },
      {
        name: "deparment",
        label: "Cơ quan/ Đơn vị",
      },
      {
        name: "purpose",
        label: "Mục đích (Yêu cầu Anh/Chị nhập chính xác thông tin nội dung)",
      },
      {
        name: "documentary",
        label: "Công văn đề nghị có chữ ký và dấu đỏ của đơn vị ngoài",
      },
      {
        name: "documentAttach",
        label: "Văn bản đính kèm",
      },
      // {
      //   name: "documentaryHead",
      //   label: "Công văn có chữ ký của lãnh đạo phòng",
      // },
      {
        name: "externalDocumentary",
        label: "Công văn đề nghị có chữ ký và dấu đỏ của lãnh đạo đối tác",
      },
      {
        name: "ecoContract",
        label: "Hợp đồng kinh tế giữa VIAGS và đối tác",
      },
      {
        name: "aviationSecurityCertification",
        label: "Chứng Chỉ Kiến Thức Chung về An Ninh Hàng Không",
      },
      {
        name: "unit",
        label: "Đơn vị",
      },
      {
        name: "fullname",
        label: "Người cần yêu cầu",
      },
      {
        name: "pickApprover",
        label: "Người duyệt",
      },
      {
        name: "findApprover",
        label: "Người duyệt thay thế",
      },
      {
        name: "pickItLead",
        label: "Bộ phận cấp thẻ VPCT",
      },
      {
        name: "findItLead",
        label: "Người cấp thẻ thay thế",
      },
      // {
      //   name: "date",
      //   label: "Thời gian",
      // },
      {
        name: "requests",
        label: "Thông tin cán bộ nhân viên",
        defaultValue: [],
      },
      {
        name: "fileRequests",
        label: "Tệp đính kèm",
        defaultValue: [],
      },
    ],
    onSubmit: async (payload) => {
      const {
        description,
        requests,
        fileRequests,
        phoneNumber,
        baseId,
        purpose,
        area,
        // documentaryHead,
        documentary,
        externalDocumentary,
        ecoContract,
        documentAttach,
        aviationSecurityCertification,
      } = payload;

      if (!phoneNumber) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập SĐT liên hệ!",
          icon: "/icons/warning.png",
        });
        return;
      }

      const formattedValue = phoneNumber.toString().padStart(10, "0");

      if (!validatePhoneNumber(formattedValue)) {
        CreateNotification({
          title: "Thông báo",
          body: "Số điện thoại không hợp lệ!",
          icon: "/icons/warning.png",
        });
        return;
      }

      if (!approver && id === 0) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng chọn thủ trưởng CQ/ĐV",
          icon: "/icons/warning.png",
        });
        return;
      }

      if (!itLead && id === 0) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng chọn bộ phận cấp thẻ",
          icon: "/icons/warning.png",
        });
        return;
      }

      /**
       * Validate data of requests is valid ??
       */
      if (contentData.length) {
        const isValidateAllRequests = validateRequests(contentData);

        if (!isValidateAllRequests) {
          CreateNotification({
            title: "Thông báo",
            body: "Thông tin cán bộ nhân viên chứa dữ liệu không hợp lệ!",
            icon: "/icons/warning.png",
          });
          return;
        }
      }

      if (!purpose || !baseId) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu",
          icon: "/icons/warning.png",
        });
        return;
      }

      if (stage === "longTerm" && !ecoContract) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu",
          icon: "/icons/warning.png",
        });
        return;
      }

      // if (documentAttach.length == 0){
      //   CreateNotification({
      //     title: "Thông báo",
      //     body: "Vui lòng đính kèm văn bản đính kèm",
      //     icon: "/icons/warning.png",
      //   });
      //   return;
      // }

      // if (documentaryHead.length == 0){
      //   CreateNotification({
      //     title: "Thông báo",
      //     body: "Vui lòng đính kèm công văn có chữ ký của lãnh đạo phòng",
      //     icon: "/icons/warning.png",
      //   });
      //   return;
      // }

      if (contentData.length == 0) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      }

      /**
       * Validate data of requests is valid ??
       */
      if (requests.length) {
        const isValidateAllRequests = validateRequests(requests);

        if (!isValidateAllRequests) {
          CreateNotification({
            title: "Thông báo",
            body: "Thông tin cán bộ nhân viên chứa dữ liệu không hợp lệ!",
            icon: "/icons/warning.png",
          });
          return;
        }
      }

      const approverTmp = employees.find((f: any) => f.eMail === approver);
      const itLeadTmp = employees.find((f: any) => f.eMail === itLead);

      const software: any = softwares.find((f: any) => f.eSystemCode === "ESCR");
      // const requestTypeText: any = codeProcessRequestTypes.find(
      //   (f: any) => f.value === sercurityCardUnitRequestType,
      // )?.label;
      const assignees = software.eITStaff.split(";");

      const eAssignee = isProduction ? `${assignees[0]}` : `namphuongtp@viags.vn|TP eOffice`

      const eprCodeRequest: any =
        id === 0
          ? {
            fields: {
              Title: `Cấp thẻ kiểm soát an ninh cho đơn vị ngoài`,
              eApprovedBy: approverTmp
                ? `${approverTmp.eMail}|${approverTmp.Title}`
                : `${approver}|${pickedUserName}`,
              eSoftwareId: software.id,
              eApprovedByITLead: itLeadTmp
                ? `${itLeadTmp.eMail}|${itLeadTmp.Title}`
                : `${itLead}|${pickedItLeadName}`,
              // eApprovedByITLead: `${software.eITTeamLead}|${software.eTeamLeadName}`,
              // eApprovedByITHead: `${software.eITHead}|${software.eITHeadName}`,
              eAssignee: eAssignee,
              eRequestStatus: requestStatus.submitted,
              eDescription: description,
              eRequestType: sercurityCardUnitRequestType,
              eStage: stage,
              eSuggestion: suggestion,
              eContent: JSON.stringify(contentData),
              eFileContent: JSON.stringify(fileRequests),
              eDepartment: id === 0 ? selectedDepartment.value : selectedDepartment,
              eUnit: id === 0 ? selectedUnit.value : selectedUnit,
              ePhoneNumber: formattedValue,
              eBaseId: baseId,
              ePurpose: purpose,
              eDeadline: setUtcTime(getDay(estimatedTimeOfUse)),
              eArea: area,
              eDocumentary: documentary.length > 0 ? JSON.stringify(documentary) : null,
              // eDocumentaryHead: documentaryHead.length > 0 ? JSON.stringify(documentaryHead) : null,
              eExternalDocumentary: externalDocumentary.length > 0 ? JSON.stringify(externalDocumentary) : null,
              eEcoContract: ecoContract.length > 0 ? JSON.stringify(ecoContract) : null,
              eDocumentAttach: documentAttach.length > 0 ? JSON.stringify(documentAttach) : null,
              eAviationSecurityCertification:
                aviationSecurityCertification.length > 0 ? JSON.stringify(aviationSecurityCertification) : null,
              eCreatedBy: user?.current?.username?.toLowerCase() || '',
            },
          }
          : {
            fields: {
              Title: `Cấp thẻ kiểm soát an ninh cho đơn vị ngoài`,
              // eApprovedBy: approverTmp
              //   ? `${approverTmp.eMail}|${approverTmp.Title}`
              //   : `${approver}|${pickedUserName}`,
              // eSoftwareId: software.id,
              // eApprovedByITLead: itLeadTmp
              //   ? `${itLeadTmp.eMail}|${itLeadTmp.Title}`
              //   : `${itLead}|${pickedItLeadName}`,
              // eApprovedByITLead: `${software.eITTeamLead}|${software.eTeamLeadName}`,
              // eApprovedByITHead: `${software.eITHead}|${software.eITHeadName}`,
              // eAssignee: `${assignees[0]}`,
              // eRequestStatus: requestStatus.submitted,
              eDescription: description,
              eRequestType: sercurityCardUnitRequestType,
              eStage: stage,
              eSuggestion: suggestion,
              eContent: JSON.stringify(contentData),
              eFileContent: JSON.stringify(fileRequests),
              // eDepartment:
              //   id === 0 ? selectedDepartment.value : selectedDepartment,
              // eUnit: id === 0 ? selectedUnit.value : selectedUnit,
              ePhoneNumber: formattedValue,
              eBaseId: baseId,
              ePurpose: purpose,
              eDeadline: setUtcTime(getDay(estimatedTimeOfUse)),
              eArea: area,
              eDocumentary: documentary.length > 0 ? JSON.stringify(documentary) : null,
              // eDocumentaryHead: documentaryHead.length > 0 ? JSON.stringify(documentaryHead) : null,
              eExternalDocumentary: externalDocumentary.length > 0 ? JSON.stringify(externalDocumentary) : null,
              eEcoContract: ecoContract.length > 0 ? JSON.stringify(ecoContract) : null,
              eDocumentAttach: documentAttach.length > 0 ? JSON.stringify(documentAttach) : null,
              eAviationSecurityCertification:
                aviationSecurityCertification.length > 0 ? JSON.stringify(aviationSecurityCertification) : null,
            },
          };
      addESCCRequest(eprCodeRequest);
    },
  });

  const sendMail = async (approver: any, eprCodeRequest: any) => {
    const url = siteUrl + "/details/" + eprCodeRequest.id;
    const arr = approver.split("|");
    const tomail = arr.length > 0 ? arr[0] : "";
    const name = arr.length > 1 ? arr[1] : "";
    const template = mailtemplates.find((m: any) => m.eMailType === "ESCTRA");
    const content = template.eContent
      .replace(mailRegexs.zero + ";", name)
      .replace(mailRegexs.one + ";", "duyệt")
      .replace(mailRegexs.two + ";", eprCodeRequest.createdBy.user.displayName)
      .replace(
        mailRegexs.three + ";",
        `${getDDMMYYYFormat(eprCodeRequest.createdDateTime)} - ${getHHmmFormat(eprCodeRequest.createdDateTime)}`,
      )
      .replace(mailRegexs.siteUrl, url);

    const subject = template.eSubject;
    const message = MailService.buildMailMesssage(subject, content, "html", tomail);
    await MailService.sendMail(message);
  };

  const onStageChange = (selectedOptions: any) => {
    setStage(selectedOptions);
    setSuggestion(
      selectedOptions === "longTerm" ? (suggestionRequest[0].value as any) : (suggestionTicketRequest[0].value as any),
    );
    setContentData([]);
  };

  const onSuggestionChange = (selectedOptions: any) => {
    setSuggestion(selectedOptions);
    setContentData([]);
  };

  const addESCCRequest = (eprCodeProcessRequest: any) => {
    if (id != 0) {
      ExternalSecurityControlCardRequestService.updateExternalSecurityControlCardRequest(
        id,
        eprCodeProcessRequest.fields,
      ).then(
        (res) => {
          CreateNotification({
            title: "Thành công",
            body: `Chỉnh sửa yêu cầu thành công.`,
            icon: "/icons/success.png",
          });
          history.push(Routes.detailExternalSercurityCardUnitsPage.path.replace(":id", id));
        },
        (error) => {
          CreateNotification({
            title: "Thất bại",
            body: `Chỉnh sửa yêu cầu thất bại.`,
            icon: "/icons/error.png",
          });
          console.log(error);
        },
      );
    } else {
      ExternalSecurityControlCardRequestService.addExternalSecurityControlCardRequest(eprCodeProcessRequest).then(
        (res) => {
          CreateNotification({
            title: "Thành công",
            body: `Tạo yêu cầu thành công.`,
            icon: "/icons/success.png",
          });
          if (eprCodeProcessRequest.fields.eApprovedBy) {
            sendMail(eprCodeProcessRequest.fields.eApprovedBy, res);
          }
          history.push(Routes.detailExternalSercurityCardUnitsPage.path.replace(":id", res.id));
        },
        (error) => {
          CreateNotification({
            title: "Thất bại",
            body: `Tạo yêu cầu thất bại.`,
            icon: "/icons/error.png",
          });
          console.log(error);
        },
      );
    }
  };

  const onApproverChange = (selectedOptions: any) => {
    setApprover(selectedOptions ? selectedOptions.value : "");
  };

  const onItLeadChange = (selectedOptions: any) => {
    setItLead(selectedOptions ? selectedOptions.value : "");
  };

  const onApproverPickerChange = (selectedOptions: any) => {
    setApprover(
      selectedOptions.target.selectedPeople[0]
        ? selectedOptions.target.selectedPeople[0].userPrincipalName.toLowerCase()
        : null,
    );
    setPickedUserName(
      selectedOptions.target.selectedPeople[0]
        ? selectedOptions.target.selectedPeople[0].displayName.toLowerCase()
        : null,
    );
  };

  const onItLeadPickerChange = (selectedOptions: any) => {
    setItLead(
      selectedOptions.target.selectedPeople[0]
        ? selectedOptions.target.selectedPeople[0].userPrincipalName.toLowerCase()
        : null,
    );
    setPickedItLeadName(
      selectedOptions.target.selectedPeople[0]
        ? selectedOptions.target.selectedPeople[0].displayName.toLowerCase()
        : null,
    );
  };

  const getApproverOptions = () => {
    let approvers: any = [];
    if (selectedDepartment && selectedDepartment.id > 0 && selectedUnit)
      approvers = employees
        .filter((f: any) => eApproveTitleCode.indexOf(f.eBizTitleCode) > -1 && f.eDepartmentCode === selectedUnit.id)
        .map((o: any) => ({
          label: o.Title,
          value: o.eMail,
          default: o.eDefault || false,
        }));
    else if (selectedDepartment && selectedDepartment.id != 0)
      approvers = employees
        .filter(
          (f: any) => eApproveTitleCode.indexOf(f.eBizTitleCode) > -1 && f.eDepartmentCode === selectedDepartment.id,
        )
        .map((o: any) => ({
          label: o.Title,
          value: o.eMail,
          default: o.eDefault || false,
        }));

    if (!isProduction) {
      approvers.push({
        label: "CB eOffice",
        value: "namphuongcb@viags.vn",
        default: true,
      });
    }

    setApproverOptions(approvers);
    // const defaultApprover = approvers.find((a: any) => a.default);
    // setApprover(defaultApprover.value || approvers[0].value);
  };

  const onDepartmentChange = (selectedOptions: any) => {
    setSelectedDepartment(selectedOptions ? selectedOptions : null);
    if (selectedOptions && typeof selectedOptions.id === "string") setSelectedUnit(selectedOptions);
    setApprover("");
  };

  const onUnitChange = (selectedOptions: any) => {
    setSelectedUnit(selectedOptions ? selectedOptions : null);
    setApprover("");
  };

  const handleInputChange = (e: any) => {
    setContentData(e);
  };

  useEffect(() => {
    if (selectedDepartment) {
      if (selectedDepartment.id === 2) {
        setUnit(unitNB);
        setSelectedUnit(null);
      } else if (selectedDepartment.id === 3) {
        setUnit(unitDN);
        setSelectedUnit(null);
      } else if (selectedDepartment.id === 1) {
        setUnit(unitTSN);
        setSelectedUnit(null);
      } else {
        setUnit([{ id: selectedDepartment.id, value: selectedDepartment.value }]);
        setSelectedUnit(selectedDepartment);
      }
    }
  }, [selectedDepartment]);

  useEffect(() => {
    if (selectedUnit && selectedUnit.id) {
      if (selectedDepartment.id === 1 || selectedDepartment.id === 2 || selectedDepartment.id === 3) {
        const id = +selectedUnit?.id?.slice(-1);
        const key = selectedUnit?.id?.slice(0, -1);
        if (key === "HQ") setTeam(id === 1 ? hq1Team : id === 2 ? hq2Team : id === 3 ? hq3Team : []);
        else if (key === "PSC") setTeam(id === 1 ? psc1Team : id === 2 ? psc2Team : id === 3 ? psc3Team : []);
        else if (key === "PVHK") setTeam(id === 1 ? pvhk1Team : id === 2 ? pvhk2Team : id === 3 ? pvhk3Team : []);
        else if (key === "GA") setTeam([{ id: "GA", value: "Bộ phận hành chính tổng hợp" }]);
        else if (key === "PVHH") setTeam([{ id: "PVHH", value: "Đội phục vụ hàng hóa" }]);
        else {
          setTeam([{ id: selectedUnit.id, value: selectedUnit.value }]);
        }
      } else {
        setTeam([{ id: selectedDepartment.id, value: selectedDepartment.value }]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUnit]);

  useEffect(() => {
    if (selectedDepartment) {
      let id = selectedDepartment.id;
      switch (id) {
        case id === 1:
          break;
      }
    }
  }, [selectedDepartment]);

  useEffect(() => {
    if (id != 0) {
      ExternalSecurityControlCardRequestService.getExternalSecurityControlCardRequest(id)
        .then((res) => {
          const {
            eDescription,
            eApprovedBy,
            // eSoftwareId,
            eRequestType,
            eContent,
            eFileContent,
            eDepartment,
            eUnit,
            ePhoneNumber,
            eStage,
            eBaseId,
            ePurpose,
            eArea,
            eDeadline,
            eSuggestion,
            eDocumentary,
            // eDocumentaryHead,
            eExternalDocumentary,
            eAviationSecurityCertification,
            eEcoContract,
            eDocumentAttach,
          } = res.fields;
          const approverEmail = eApprovedBy.split("|")[0];
          setValues({
            description: eDescription,
            requests: JSON.parse(eContent),
            fileRequests: JSON.parse(eFileContent),
            phoneNumber: ePhoneNumber,
            baseId: eBaseId,
            purpose: ePurpose,
            area: eArea,
            documentary: eDocumentary?.length > 0 ? JSON.parse(eDocumentary) : [],
            // documentaryHead: eDocumentaryHead?.length > 0 ? JSON.parse(eDocumentaryHead) : [],
            externalDocumentary: eExternalDocumentary?.length > 0 ? JSON.parse(eExternalDocumentary) : [],
            aviationSecurityCertification:
              eAviationSecurityCertification?.length > 0 ? JSON.parse(eAviationSecurityCertification) : [],
            ecoContract: eEcoContract?.length > 0 ? JSON.parse(eEcoContract) : [],
            documentAttach: eDocumentAttach?.length > 0 ? JSON.parse(eDocumentAttach) : [],
          });
          setEstimatedTimeOfUse(eDeadline);
          setStage(eStage);
          setApprover(approverEmail);
          setsercurityCardUnitRequestType(eRequestType);
          setSelectedDepartment(eDepartment);
          setSelectedUnit(eUnit);
          setSuggestion(eSuggestion);
          setContentData(JSON.parse(eContent));
        })
        .catch((error) => console.log(error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    getApproverOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDepartment, selectedUnit]);

  return (
    <div className="ITCodeGrantedCreateNewPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div
              className="btnBack"
              onClick={() => history.push(Routes.ProcessSecurityControlCardsToExternalUnits.path)}
            >
              <Icon.ArrowLeft />
            </div>
            {id === 0 ? "Tạo Yêu Cầu Cấp Thẻ KSAN Cho Đơn Vị Ngoài" : "Chỉnh sửa Yêu Cầu Cấp Thẻ KSAN Cho Đơn Vị Ngoài"}
          </div>
        </div>
        <form onSubmit={handleSubmit}>
          <Box title="Giai đoạn" className="form__content">
            <InputWraper
              className="pb-3"
              inputProps={getInputProps("stage")}
              renderInput={(s) => (
                <InputSelectTag {...s} options={stageRequest} value={stage} onChange={onStageChange} />
              )}
            />
            <InputWraper
              className="pb-3"
              inputProps={getInputProps("type")}
              renderInput={(s) => (
                <InputSelectTag
                  {...s}
                  options={stage === "shortTerm" ? suggestionTicketRequest : suggestionRequest}
                  value={suggestion}
                  onChange={onSuggestionChange}
                />
              )}
            />
          </Box>
          <Box title="Thông tin" className="form__content">
            {id === 0 && (
              <Row>
                <Col sm="6" md="6">
                  <InputWraper
                    inputProps={getInputProps("deparment")}
                    isRequired
                    renderInput={(s) => (
                      <InputSelect
                        {...s}
                        options={department.map((o: any) => ({
                          id: o.id,
                          label: o.value,
                          value: o.value,
                        }))}
                        value={selectedDepartment}
                        onChange={onDepartmentChange}
                        placeholder="* Chọn Cơ quan/ đơn vị"
                      />
                    )}
                  />
                </Col>
                <Col sm="6" md="6">
                  <InputWraper
                    inputProps={getInputProps("unit")}
                    isRequired
                    renderInput={(s) => (
                      <InputSelect
                        {...s}
                        options={unit.map((o: any) => ({
                          id: o.id,
                          label: o.value,
                          value: o.value,
                        }))}
                        value={selectedUnit?.value}
                        onChange={onUnitChange}
                        placeholder={"* Chọn đơn vị"}
                      />
                    )}
                  />
                </Col>
              </Row>
            )}
            <InputWraper
              inputProps={getInputProps("phoneNumber")}
              renderInput={(s) => <InputNumber {...s} />}
              isRequired
            />
          </Box>
          <Box title="Thông tin đề nghị cấp giấy phép" className="form__content">
            <Row>
              <Col md="6" sm="6">
                <InputWraper
                  inputProps={getInputProps("baseId")}
                  renderInput={(s) => <InputText {...s} />}
                  isRequired
                />
              </Col>
              <Col md="6" sm="6">
                <InputWraper
                  inputProps={getInputProps("documentAttach")}
                  renderInput={(s) => <Upload {...s} />}
                // isRequired
                />
              </Col>
              {/* <Col md="6" sm="6">
                  <InputWraper
                    inputProps={getInputProps("date")}
                    renderInput={(s) => (
                      <>
                        <InputDateTime
                          {...s}
                          value={estimatedTimeOfUse}
                          onChange={onEstimatedTimeOfUseChange}
                        />
                      </>
                    )}
                    isRequired
                    className="estimatedTimeOfUse"
                  />
                </Col> */}
            </Row>
            <Row>
              <Col md="6" sm="6">
                <InputWraper
                  inputProps={getInputProps("purpose")}
                  renderInput={(s) => <InputText {...s} />}
                  isRequired
                />
              </Col>
              <Col md="6" sm="6">
                <InputWraper
                  inputProps={getInputProps("aviationSecurityCertification")}
                  renderInput={(s) => <Upload {...s} />}
                />
              </Col>
              {/* <Col md="6" sm="6">
                            <InputWraper
                              inputProps={getInputProps("documentaryHead")}
                              renderInput={(s) => <Upload {...s} />}
                              isRequired
                            />
                    </Col>   */}
            </Row>
            <Row>
              {stage !== "longTerm" ? (
                <>
                  <Col md="12" sm="12">
                    <InputWraper
                      inputProps={getInputProps("documentary")}
                      renderInput={(s) => <Upload {...s} />}
                    // isRequired
                    />
                  </Col>
                </>
              ) : (
                <>
                  <Col md="6" sm="6">
                    <InputWraper
                      inputProps={getInputProps("externalDocumentary")}
                      renderInput={(s) => <Upload {...s} />}
                    // isRequired
                    />
                  </Col>
                  <Col md="6" sm="6">
                    <InputWraper
                      inputProps={getInputProps("ecoContract")}
                      renderInput={(s) => <Upload {...s} />}
                      isRequired
                    />
                  </Col>
                </>
              )}
              {/* <Col md="6" sm="6">
                  <InputWraper
                    inputProps={getInputProps("area")}
                    renderInput={(s) => <InputText {...s} />}
                    isRequired
                  />
                </Col> */}
            </Row>
            {/* <Row>
                    
              </Row> */}
          </Box>
          <Box title="Thông tin cán bộ nhân viên" className="form__content">
            <InputWraper
              className="from__container-input"
              inputProps={getInputProps("requests")}
              renderInput={(state) =>
                stage === "longTerm" ? (
                  <InputArrayData
                    {...state}
                    teamList={team}
                    isSelectUnit={selectedUnit ? 1 : 0}
                    onChange={handleInputChange}
                    value={contentData}
                    form={
                      suggestion === "provide"
                        ? LongTermNewSecurityControlCardContentForm
                        : suggestion === "evict"
                          ? LongTermEvictSecurityControlCardContentForm
                          : LongTermRenewSecurityControlCardContentForm
                    }
                    structure={
                      suggestion === "provide"
                        ? LongTermNewSercurityCardUnitsFormStructure
                        : suggestion === "evict"
                          ? LongTermEvictSercurityCardUnitsFormStructure
                          : longTermRenewSecurityControlCardStructure
                    }
                    excelTemplate={
                      suggestion === "provide"
                        ? "security-cards-to-external-entities-long-term-provide"
                        : suggestion === "evict"
                          ? "security-cards-to-external-entities-long-term-evict"
                          : "security-cards-to-external-entities-long-term-renew"
                    }
                  />
                ) : (
                  <InputArrayData
                    {...state}
                    teamList={team}
                    isSelectUnit={selectedUnit ? 1 : 0}
                    onChange={handleInputChange}
                    value={contentData}
                    form={
                      suggestion === "provide"
                        ? ShortTermSercurityCardUnitsControlForm
                        : ShortTermRenewSercurityCardUnitsControlForm
                    }
                    structure={
                      suggestion === "provide"
                        ? ShortTermSercurityCardUnitsFormStructure
                        : ShortTermRenewSercurityCardUnitsFormStructure
                    }
                    excelTemplate={
                      suggestion === "provide"
                        ? "security-cards-to-external-entities-provide"
                        : "security-cards-to-external-entities-renew"
                    }
                  />
                )
              }
            />

            <InputWraper inputProps={getInputProps("fileRequests")} renderInput={(s) => <Upload {...s} />} />

            {id === 0 && (
              <>
                <Row>
                  <Col sm="6" md="6">
                    <InputWraper
                      inputProps={getInputProps("pickApprover")}
                      renderInput={(s) => (
                        <UserSelect
                          {...s}
                          placeholder="Thủ trưởng CQ/ĐV"
                          options={approverOptions}
                          value={approver}
                          onChange={onApproverChange}
                        />
                      )}
                      isRequired
                    />
                  </Col>
                  <Col sm="6" md="6">
                    <InputWraper
                      inputProps={getInputProps("findApprover")}
                      renderInput={(s) => (
                        <div className="people_picker-custom">
                          <PeoplePicker
                            className="people-picker"
                            placeholder="Thủ trưởng CQ/ĐV"
                            type={PersonType.any}
                            selectionChanged={onApproverPickerChange}
                          />
                        </div>
                      )}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="6" md="6">
                    <InputWraper
                      inputProps={getInputProps("pickItLead")}
                      renderInput={(s) => (
                        <UserSelect
                          {...s}
                          placeholder="Bộ phận cấp thẻ VPCT"
                          options={eApprovedOptions}
                          value={itLead}
                          onChange={onItLeadChange}
                        />
                      )}
                      isRequired
                    />
                  </Col>
                  <Col sm="6" md="6">
                    <InputWraper
                      inputProps={getInputProps("findItLead")}
                      renderInput={(s) => (
                        <div className="people_picker-custom">
                          <PeoplePicker
                            className="people-picker"
                            placeholder="Bộ phận cấp thẻ VPCT"
                            type={PersonType.any}
                            selectionChanged={onItLeadPickerChange}
                          />
                        </div>
                      )}
                    />
                  </Col>
                </Row>
              </>
            )}
          </Box>
          <div className="textRight">
            <Button type="submit" label="Xác nhận" isLoading={isSubmitting} />
            <Button
              type="button"
              label="Huỷ"
              buttonType="grey-outline"
              className="ml10"
              onClick={() => history.push(Routes.ProcessSecurityControlCardsToExternalUnits.path)}
            />
          </div>
        </form>
      </div>
    </div>
  );
});
